import React from 'react';
import { Prompt } from '../../types';
import PromptCard from './PromptCard';
import LoadingSpinner from '../common/LoadingSpinner';

interface PromptListProps {
  prompts: Prompt[];
  loading: boolean;
  error: string | null;
  onSelectPrompt: (prompt: Prompt) => void;
  onCopyPrompt: (content: string) => void;
  onToggleFavorite?: (promptId: number) => void;
  favoriteIds?: number[];
  layout?: 'grid' | 'list';
  emptyMessage?: string;
}

const PromptList: React.FC<PromptListProps> = ({
  prompts,
  loading,
  error,
  onSelectPrompt,
  onCopyPrompt,
  onToggleFavorite,
  favoriteIds = [],
  layout = 'grid',
  emptyMessage = '프롬프트를 찾을 수 없습니다.',
}) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <div className="text-red-600 mb-2">오류가 발생했습니다</div>
        <div className="text-gray-600 text-sm">{error}</div>
      </div>
    );
  }

  if (prompts.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-500 text-lg mb-2">🔍</div>
        <div className="text-gray-600">{emptyMessage}</div>
      </div>
    );
  }

  const gridClasses = layout === 'grid' 
    ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-fr'
    : 'space-y-3';

  return (
    <div className={gridClasses}>
      {prompts.map((prompt) => (
        <PromptCard
          key={prompt.id}
          prompt={prompt}
          onSelect={onSelectPrompt}
          onCopy={onCopyPrompt}
          onToggleFavorite={onToggleFavorite}
          isFavorite={favoriteIds.includes(prompt.id)}
          compact={layout === 'list'}
        />
      ))}
    </div>
  );
};

export default PromptList;